/* eslint-disable */
import SceneBase from "./common/SceneBase";
import Helper from "./common/Helper";
import Particle from "./common/Particle";
import CharaHuman from "./scene_achievement/chara/CharaHuman";
import CharaLandscape from "./scene_achievement/chara/CharaLandscape";
import StepPlace from "./scene_achievement/step/StepPlace";
import StepMember from "./scene_achievement/step/StepMember";
import StepDate from "./scene_achievement/step/StepDate";
import StepDistance from "./scene_achievement/step/StepDistance";
import StepEnd from "./scene_achievement/step/StepEnd";
import OsmMapManager from "./osm_map/OsmMapManager";

class SceneAchievement extends SceneBase {
  constructor(engine) {
    super(engine);

    this.step = "";
    this.stepList = [];

    //particle
    this.particle = new Particle(this.scene);
  }

  //------------------------------------
  // setup
  //------------------------------------
  setup() {
    super.setup();

    //step
    this.stepList["place"] = new StepPlace(this.scene);
    this.stepList["member"] = new StepMember(this.scene);
    this.stepList["date"] = new StepDate(this.scene);
    this.stepList["distance"] = new StepDistance(this.scene);
    this.stepList["end"] = new StepEnd(this.scene);

    //open street map
    this.osmMapManager = new OsmMapManager(this.scene);
    this.osmMapManager.getRoot().parent = this.getRoot();
    this.osmMapManager.getRoot().scaling.x = 20;
    this.osmMapManager.getRoot().scaling.y = 20;
    this.osmMapManager.getRoot().scaling.z = 20;

    //charactor
    this.charaHuman = new CharaHuman(this.scene);
    this.charaLandscape = new CharaLandscape(this.scene);
  }

  //------------------------------------
  // Camera
  //------------------------------------
  initCamera() {
    super.initCamera();
    this.camera.setPosition(new BABYLON.Vector3(0, 60, 40));
    this.camera.setTarget(new BABYLON.Vector3(0, 0, 0));
    this.scene.activeCamera = this.camera;
  }

  //------------------------------------
  // changeStatus
  //------------------------------------
  changeStatus(bool) {
    if (this.status !== bool) {
      if (bool) {
        this.particle.start();
      } else {
        this.particle.stop();
      }
    }

    super.changeStatus(bool);
  }

  //------------------------------------
  // Step Control
  //------------------------------------
  changeStep(step) {
    this.step = step;

    switch (this.step) {
      case "place":
        //change charactor setting
        this.charaHuman.startAnimation("Place", true);

        //change particle setting
        this.particle.updateScale(new BABYLON.Vector3(500, 500, 500));
        this.particle.changeDate(new Date());

        this.wipeOpen();
        break;
      case "member":
        //change charactor setting
        this.charaHuman.changePosition(new BABYLON.Vector3(0, 0, 0), 1);
        this.charaHuman.startAnimation("Member", true);

        //change particle setting
        this.particle.updateScale(new BABYLON.Vector3(500, 500, 500));
        this.particle.changeDate(new Date());
        break;
      case "date":
        //change particle setting
        this.particle.updateScale(new BABYLON.Vector3(500, 500, 500));
        this.particle.changeDate(new Date());
        break;
      case "distance":
        break;
      case "end":
        setTimeout(() => {
          this.wipeClose();
        }, 500);
        break;
    }
  }

  changeMember(member) {
    this.stepList["member"].changeMember(member);
  }

  changeDate(date) {
    this.particle.changeDate(date);
  }

  changeDistance(distance) {
    this.stepList["distance"].changeDistance(distance);

    let d = Helper.getPlanetPosition(distance);
    this.particle.updateScale(new BABYLON.Vector3(d * 2, d * 2, d * 2));
    this.particle.updatePosition(new BABYLON.Vector3(0, d / 2, 0));
  }

  // Map
  async loadMap(lat, lon) {
    await this.osmMapManager.create(
      {
        lat: lat,
        lon: lon
      },
      24
    );

    //animation
    this.charaHuman.changePosition(new BABYLON.Vector3(0, 100, 0), 100);
    this.charaLandscape.startAnimation();
  }

  resetMap() {
    this.osmMapManager.reset();

    //animation
    this.charaHuman.changePosition(new BABYLON.Vector3(0, 0, 0), 50);
    this.charaLandscape.backAnimation();
  }

  //------------------------------------
  // Update
  //------------------------------------
  update() {
    if (this.status) {
      super.update();

      //rotation update
      let rotationSpeed = this.stepList[this.step].getCameraRotationSpeed();
      this.getRoot().rotation.y += rotationSpeed;

      //camera update
      this.cameraPosition = this.stepList[this.step].getCameraPosition();
      this.cameraTarget = this.stepList[this.step].getCameraTarget();

      this.updateCamera(
        this.cameraPosition,
        this.cameraTarget,
        this.cameraSpeed
      );

      //parts update
      this.stepList[this.step].update();
      this.osmMapManager.update();

      //charactor update
      switch (this.step) {
        case "place":
          this.charaHuman.update();
          break;
      }
    }
  }
}
export default SceneAchievement;

//reset current step
//this.resetMap();
//this.changeMember(0);

//reset current step
//this.changeMember(0);
//this.changeDate(new Date());

//reset current step
//this.changeDate(new Date());
//this.changeDistance(0);

//reset current step
//this.changeDistance(0);
